import styled from "@emotion/styled";
import { StyledImage } from "../../../components/Image/Image";

export const CategoryImage = styled(StyledImage)`
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  object-fit: contain;
  max-height: ${({ height }) => height || "84px"} !important;
  min-height: ${({ height }) => height || "84px"} !important;
`;
